import React from "react";

const TermInfo = () => {
  return (
    <div>
      <ul>
        <li className="violet">&</li>
        <li className="text-primary">krishkashiwala</li>
        <li>@</li>
        <li
          style={{
            color: "greenyellow",
          }}
        >
          kkcodes
        </li>
        <li>:~$</li>
      </ul>
      <div className="arrow">{">"}</div>
    </div>
  );
};

export default TermInfo;
